module.exports = __webpack_public_path__ + "static/media/mes6.a460ac84.png";